import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/mangaData';

const ranked = [...mangaList].sort((a, b) => b.rating - a.rating).slice(0, 8);

export default function RankingSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
              热门排行榜
            </h2>
            <p className="text-sm text-foreground-500">评分最高的韩国漫画精选</p>
          </div>
          <Link
            to="/category/lianai"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {ranked.map((manga, index) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id === 'm2' ? 'a2' : manga.id === 'm5' ? 'a3' : 'a1'}`}
              className="group relative bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2 w-7 h-7 rounded-lg bg-primary-500 flex items-center justify-center">
                  <span className="text-xs font-bold text-background-50">{index + 1}</span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {manga.title}
                </h3>
                <div className="flex items-center gap-2 mt-1.5">
                  <div className="flex items-center gap-0.5">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    <span className="text-xs font-medium text-foreground-600">{manga.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{manga.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/lianai"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}